import { servicosSaudeBairrosApi } from '@/api/ServicosSaudeBairro';
import { BairroCadastroDTO } from "@/api/cadastro/saude/BairroCadastroDTO";

class SaudeBairroService {

  salvar(bairro: BairroCadastroDTO) {
    return servicosSaudeBairrosApi.salvarBairro(bairro);
  }

  atualizar(idBairro: number, bairro: BairroCadastroDTO) {
    return servicosSaudeBairrosApi.atualizarBairro(idBairro, bairro);
  }

  obterPorId(idBairro: Number) {
    return servicosSaudeBairrosApi.obterBairroPorId(idBairro);
  }

  obterPorCidade(cidade: string) {
    return servicosSaudeBairrosApi.obterBairrosPorCidade(cidade);
  }

  deletar(idBairro: Number) {
    return servicosSaudeBairrosApi.deletarBairro(idBairro);
  }
}

export const saudeBairroService = new SaudeBairroService();
